import { render, staticRenderFns } from "./RbxFileList.vue?vue&type=template&id=488be76e&"
import script from "./RbxFileList.vue?vue&type=script&lang=js&"
export * from "./RbxFileList.vue?vue&type=script&lang=js&"
import style0 from "./RbxFileList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RbxFileList.vue"
export default component.exports